/**
* this is the component for the application button with icon (if provided)
*
* Created by Tom on 25/5/17
*/

import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

// style import
import './style.scss'

const AppButton = ({buttonText, size, color, onClick, type, className}) => {

    // class expression
    let dynClass = cx('app-button', 'app-button--' + size, 'app-button--' + color, className)

    return (
        <button className={dynClass} onClick={onClick} type={type}>
          {buttonText}
        </button>
    )
}

// define the prop types
AppButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    buttonText: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
    type:  PropTypes.string,
}

export default AppButton



// WEBPACK FOOTER //
// ./src/components/AppButton/index.js